/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */

/* 该文件工具自动生成，请勿直接修改！！！ */

// @ts-ignore

import request from '@/utils/request/index';

export const imUserToken = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.ImUserTokenRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.ImUserTokenResponse, OT>>(
    '/im/user/token',
    'POST',
    data,
    options
  );

  /* prettier-ignore-end */
